// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"a6a653e9","61":"fbe5ab3f","118":"2bb4be65","333":"0f780aa4","954":"fb4ff8e2"}[chunkId] + ".chunk.js";
};